import { ChirpTag, type ChirpTagVariant } from '@chewy/chirp-tag';
import '@chewy/chirp-tag/styles.css';

import styles from './OrderStatus.module.scss';

export interface OrderStatusProps {
  status: string;
  label?: string;
}

export function getStatusType(status: string): ChirpTagVariant {
  switch (status.toLowerCase()) {
    case 'awaiting return':
    case 'available for pickup':
    case 'in transit':
    case 'ordered':
    case 'out for delivery':
    case 'package refused':
    case 'pending pharmacist review':
    case 'pending vet approval':
    case 'preparing for shipment':
    case 'refund pending':
    case 'refund processing':
    case 'replacement ordered':
    case 'replacement pending':
    case 'returned':
    case 'return processing':
    case 'return received - refund processing':
    case 'return received':
    case 'shipped':
    case 'verifying authorization':
      return 'info';

    case 'approved':
    case 'delivered':
    case 'refunded':
    case 'replaced':
      return 'success';

    case 'canceled':
    case 'delayed':
    case 'hold':
    case 'in review':
    case 'mail in prescription':
    case 'on hold - please contact chewy':
    case 'on hold - please contact vet':
    case 'unknown':
    case 'upload authorization':
      return 'caution';

    case 'damaged':
    case 'declined':
    case 'lost':
    case 'undeliverable':
    case 'expired':
    case 'package lost':
      return 'error';

    default:
      return 'info';
  }
}

export default function OrderStatus({ status, label }: OrderStatusProps) {
  const variant = getStatusType(status);
  const showDefaultIcon = status.toLowerCase() === 'delivered';

  return (
    <ChirpTag
      className={styles.orderStatus}
      label={label || status}
      variant={variant}
      icon={showDefaultIcon ? undefined : null}
    />
  );
}
